// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "fe1dfa260ea4a610bd3ead9a09393f02" + ".js";
};